module.exports = __webpack_public_path__ + "media/pac-man.88665183.wav";